<template>
    <div>
        <div class="pageTitleWrap">
            <!-- <div class="pageTitle">商品系统</div> -->
            <!-- <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb> -->
            <vs-breadcrumb class="marLeft12" separator="/">
                  <!-- <li @click="back">返回<span class="vs-breadcrum--separator">/</span></li> -->
                  <li class="active" @click="back" style="cursor:pointer">订单管理<span class="vs-breadcrum--separator">/</span></li>
                  <!-- <li><router-link :to="parentUrl">订单管理</router-link><span class="vs-breadcrum--separator">/</span></li> -->
                   <li aria-current="page" class="active">订单详情</li>
            </vs-breadcrumb>
        </div>
        <div class="main-wrap">
            <div class="top-title">
                <div :class="detail.orderStatus == 'TO_SEND' || detail.orderStatus == 'TO_REVIEW' ? 'title yellow-text' : 'title'">{{ detail.orderStatusDesc }}</div>
                <div class="marLeft20">订单编号：{{ detail.orderNo }}</div>
                <div class="marLeft20">下单时间：{{ detail.orderTime }}</div>
                <div class="marLeft20">订单渠道：{{ detail.sourceChannelDesc }}</div>
				<div class="marLeft20 log-btn" @click='getLogList'>订单操作日志</div>
            </div>
            <div class="bot-content">
                <div class="detail-info">
                    <div class="lf item">
                        <div class="title line">
                            收货信息

                            <div v-if="editFlag == 'true'">
                                <span v-if="!isEditReceiveUser" style="cursor:pointer" @click="isEditReceiveUser = !isEditReceiveUser" class="btn">
                                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary" />
                                    修改
                                </span>
                                <span v-if="isEditReceiveUser" style="cursor:pointer" @click="editReceiveUser" class="ebtn btn">保存</span>
                                <span v-if="isEditReceiveUser" style="cursor:pointer" @click="isEditReceiveUser = false" class="ebtn btn">取消</span>
                            </div>
                        </div>
                        <div class="content">
                            <div class="">
                                收货人:
                                <vs-input size="small" v-if="isEditReceiveUser" class="edit_row_input" v-model="detail.receiveName"></vs-input>
                                <span v-else>{{ detail.receiveName }}</span>
                            </div>
                            <div>
                                联系方式:
                                <vs-input size="small" v-if="isEditReceiveUser" type="tel" maxlength="11" class="edit_row_input" v-model="detail.receivePhone"></vs-input>
                                <span v-else>{{ detail.receivePhone }}</span>
                            </div>
                            <div style="display:flex">
                                <span :style="isEditReceiveUser ? 'padding-top: 10px;' : ''" style="margin-right:5px;">收货地址: </span>
                                <p class="w200" v-if="isEditReceiveUser">
                                    <el-cascader size="small" :options="options" class="edit_row_input" v-model="selectedOptions" @change="handleChange"></el-cascader>
                                    <vs-input size="small" class="edit_row_input" v-model="detail.address"></vs-input>
                                </p>
                                <span v-else>{{ detail.addressAll }}</span>
                            </div>
                            <div v-if=" detail.sendWs">
                                发货仓:
                                <span>{{ detail.sendWs }}</span>
                            </div>
                            <div v-if="detail.billSendBo  && (detail.billSendBo.expressProvider != '' || detail.billSendBo.expressNo)">
                                快递/物流:
                                <span>{{ (detail.billSendBo.expressProvider || '')+ (detail.billSendBo.expressNo || '') }}</span>
                            </div>
                        </div>
                    </div>                   
                    <div class="lf item">
                        <div class="title">买家信息</div>
                        <div class="content">
                            <div>买家名称: {{ detail.buyerName }}</div>
                            <div>买家类型: {{ detail.buyerType }}</div>
                            <div>买家留言: {{ detail.buyerRemark }}</div>
                        </div>
                    </div>
                     <div class="rt item">
                        <div class="title">其他信息</div>
                        <div class="content">
                          <div>需求部门: {{ detail.fromDepart }}</div>
                          <div>需求人员: {{ detail.fromUser }}</div>
                          <div>线下PI号: {{ detail.piNo }}</div>
                        </div>
                    </div>
                </div>
                <!-- 支付方式 -->
                <div class="sale-remark">
                  <div class="label">支付信息</div>
                </div>
                <div class="detail-info">           
                  <div class="mid item large" style="min-height: 80px" v-if="!detail.payRecords.length && (!detail.payPics || !detail.payPics.length)">暂无数据</div>       
                  <div class="mid item large" v-else>
                    <div class="title line end">
                        <!-- <div>支付信息</div> -->
                        <div v-if="detail.payPics && detail.payPics.length" class="btn" @click="payPicsShow = true">
                            查看支付凭证
                        </div>
                    </div>
                    <div class="pay-list">
                      <div class="content pay-content" v-for="(item,index) in detail.payRecords" :key="index">
                        <div class="width20">{{ index+1 }}</div>
                        <div class="width50"> {{ item.onlinePay ? '线上支付': '手工支付' }}</div>
                        <div class="width200">实付金额: {{ item.payPrice | currencyFormat(2, false, currencyShow) }}</div>
                        <!-- <div>实付金额: {{ detail.totalPrice }}</div> -->
                        <div class="width150">支付方式: {{ item.payTypeDesc }}</div>
                        <div class="width200">支付时间: {{ item.payTime }}</div>
                        <div class="width400">支付单号：{{item.payNo || ''}}</div>
                        <div class="cancel-pay" v-if="!item.onlinePay" @click="delPay(item)">
                            取消
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>
                <div class="sku-info">
                    <div class="label">订单商品信息<vs-button style="margin-left: 10px" color="primary" size="small" v-if="editFlag == 'true' && detail.seller == 1 && detail.isSplitOrder == 0 && detail.orderStatus == 'TO_REVIEW'" @click="handleSeparateBill">拆单</vs-button></div>

                    <skuList :skuData="detail.skuItems" :orderNo="orderNo" :editFlag="editFlag" ref="skuItem"
                              @getAddPayList='getAddPayList' @getSellerRemark="getSellerRemark" @getAmountInfo="getAmountInfo" :newOrder="false"
                              @getReceiveInfo="getReceiveInfo" @updateCurrency="updateCurrency"></skuList>
                </div>
                 <div class="sale-remark">
                    <div class="label">卖家备注</div>
                    <vs-input v-model="detail.sellerRemark" class="w-full" placeholder="请输入卖家备注" />
                </div>
            </div>
            <div class="btn-group" v-if="editFlag == 'true'">
                <vs-button color="primary" icon-pack="feather" class="btn" v-if="detail.orderStatus == 'TO_SEND'">发货</vs-button>
                <vs-button color="primary" icon-pack="feather" class="btn"   @click="verifyConfirm" v-if="detail.orderStatus == 'TO_REVIEW'">审核确认</vs-button>
                <vs-button
                    v-if="detail.orderStatus != 'SEND_ED' && detail.orderStatus != 'CANCEL_ED' && detail.orderStatus != 'ABNORMAL' && detail.orderStatus != 'RECEIV_ED'"
                    type="border"
                    color="primary"
                    icon-pack="feather"
                    class="btn"
                    @click="cancelOrder"
                >
                    取消订单
                </vs-button>
                <vs-button
                    v-if="detail.orderStatusDesc === '已推单' || detail.billSendBo && detail.billSendBo.expressNo == ''"
                    type="border"
                    color="primary"
                    icon-pack="feather"
                    class="btn"
                    @click="cancelDriveOrder"
                >
                    取消推单
                </vs-button>
                <vs-button
                    v-if="detail.orderStatus != 'SEND_ED' && detail.orderStatus != 'RECEIV_ED' && detail.orderStatus != 'CANCEL_ED' && detail.orderStatus != 'ABNORMAL'"
                    type="border"
                    color="#FF433D"
                    icon-pack="feather"
                    class="btn"
                    @click="toAbnormal"
                >
                    转异常
                </vs-button>
            </div>
        </div>
        <!-- 标注异常弹窗 -->
        <vs-popup classContent="popup-example abnormal" title="标注异常" :active.sync="popupActive2Bzyc">
            <form class="frombox" id="data-list-list-view">
                <vs-row>
                    <vs-col vs-w="2" class="colTitle">异常原因</vs-col>
                    <vs-col vs-w="5"><v-select :options="TreeAbnormal" v-model="AbnormalModel" label="val" :reduce="opt => opt.key" :dir="$vs.rtl ? 'rtl' : 'ltr'" /></vs-col>
                </vs-row>
            </form>
            <vs-row style="margin-top:20px">
                <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OnOrderAbnormal" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OrderAbnormalbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
            </vs-row>
        </vs-popup>
        <!-- 发货弹窗 -->
        <vs-popup classContent="popup-example deliver-pop" title="发货" :active.sync="showDeliverPop">
            <form class="frombox" id="data-list-list-view">
                <vs-row class="alignCenter">
                    <vs-col vs-w="2">选择运费模板</vs-col>
                    <vs-col vs-w="5" vs-offset="0.2">
                        <v-select v-model="deliverParam.frtId" :options="tmsFrtOptions" :reduce="opt => opt.id" placeholder="请选择运费模板">
                            <div slot="no-options">暂无选项</div>
                        </v-select>
                    </vs-col>
                </vs-row>
                <vs-row class="alignCenter marTop20">
                    <vs-col vs-w="2">选择仓库</vs-col>
                    <vs-col vs-w="5" vs-offset="0.2">
                        <v-select
                            v-model="deliverParam.wsId"
                            :options="distOptions"
                            :reduce="opt => opt.id"
                            placeholder="请选择仓库"
                            @change="getLocOptions"
                            @input="getLocOptions"
                        >
                            <div slot="no-options">暂无选项</div>
                        </v-select>
                    </vs-col>
                </vs-row>
                <vs-row class="alignCenter marTop20">
                    <vs-col vs-w="2">选择仓位</vs-col>
                    <vs-col vs-w="5" vs-offset="0.2">
                        <v-select v-model="deliverParam.locId" :options="locOptions" :reduce="opt => opt.id" placeholder="请选择仓位">
                            <div slot="no-options">暂无选项</div>
                        </v-select>
                    </vs-col>
                </vs-row>
            </form>
            <div class="deliver-btn flex flexCenter">
                <vs-button color="primary" type="filled" @click="deliverOrder">确认发货</vs-button>
                <vs-button color="primary" type="border" style="margin-left:9px;">取消</vs-button>
            </div>
        </vs-popup>
        <!-- 审核确认弹窗 -->
        <!-- <vs-popup classContent="popup-example" title="审核确认" :active.sync="popupActive2Shqr">
            <div class="modal-title">是否确认审核此订单</div>
            <vs-row style="margin-top:20px">
                <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OnconfirmOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="Onconfirmbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
            </vs-row>
        </vs-popup> -->
         <!-- 审核确认弹窗 -->
        <vs-prompt
            class="verify"
            classContent="popup-example"
            title="审核确认"
            acceptText="确认审核"
            cancelText="取消"
            :active.sync="popupActive2Shqr"
            :is-valid="validateVerify"
            @cancel="popupActive2Shqr=false"
            @accept="OnconfirmOrder">
                <div class="flex alignCenter deliver-dialog">
                <div class="flex alignCenter">
                    <div>选择仓库</div>
                    <template>
                        <v-select
                            v-model="deliverParam.wsId"
                            :options="distOptions"
                            :reduce="opt => opt.id"
                            placeholder="请选择仓库"
                            @change="getLocOptions"
                            @input="getLocOptions"
                            class="marLeft16"
                        >
                            <div slot="no-options">暂无选项</div>
                        </v-select>
                    </template>
                </div>
                
                <div class="flex alignCenter marLeft16">
                    <div>选择仓位</div>
                    <template>
                        <v-select v-model="deliverParam.locId" 
                                :options="locOptions" 
                                :reduce="opt => opt.id" 
                                placeholder="请选择仓位"
                                class="marLeft16">
                            <div slot="no-options">暂无选项</div>
                        </v-select>
                    </template>
                </div>
            </div>
                <el-table
                :data="stockTabledata"
                class="marTop20"
                :span-method="columnSpanMethod"
                height="300"
                style="width: 100%"
                :row-class-name="tableRowClassName">
                <el-table-column
                    v-for="item in stockColumns"
                    :label="item.name"
                    :prop="item.code"
                    :key="item.code"
                    :width="item.width">
                </el-table-column>
            </el-table>
        </vs-prompt>
        <!-- 取消推单弹窗 -->
        <vs-popup classContent="popup-example" title="取消推单" :active.sync="popupActive2Zxdd">
            <div class="modal-title" style="margin-left:22px">您正在取消推单，注意取消后订单会变为‘待发货’，如需发货需重新推单！</div>
            <form class="frombox" style="margin-top:50px" id="data-list-list-view">
                <vs-row>
                    <vs-col vs-w="3" class="colTitle">取消推单原因说明</vs-col>
                    <vs-col vs-w="9"><vs-input v-model="cancelDriveModel" class="w-full" placeholder="输入取消推单原因" /></vs-col>
                </vs-row>
            </form>
            <vs-row style="margin-top:20px">
                <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelDriveOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OncancelDrivebtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
            </vs-row>
        </vs-popup>
        <!-- 取消订单弹窗 -->
        <vs-popup classContent="popup-example" title="取消订单" :active.sync="popupActive2Qxdd">
            <div class="modal-title" style="margin-left:22px">您正在取消订单，注意取消订单将会同步到客户，请仔细考虑操作</div>
            <form class="frombox" style="margin-top:50px" id="data-list-list-view">
                <vs-row>
                    <vs-col vs-w="3" class="colTitle">取消原因说明</vs-col>
                    <vs-col vs-w="9"><vs-input v-model="cancelModel" class="w-full" placeholder="输入取消原因" /></vs-col>
                </vs-row>
            </form>
            <vs-row style="margin-top:20px">
                <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="Oncancelbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
            </vs-row>
        </vs-popup>
        <!-- 转正常弹窗 -->
        <vs-popup classContent="popup-example" title="转正常" :active.sync="popupActive2Zzc">
            <div class="modal-title">确定将此订单转为正常吗？</div>
            <vs-row style="margin-top:20px">
                <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OnNormalOk" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="normalbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
            </vs-row>
        </vs-popup>
		
		<!-- 操作日志 -->
		<vs-popup classContent="popup-example deliver-pop" title="操作日志" :active.sync="isShowLogList" class='log-popup'>
			<vs-table :data="logList">
				<template slot="thead">
					<vs-th>操作人</vs-th>
					<vs-th>操作时间</vs-th>
					<vs-th>操作内容</vs-th>
				</template>
		
				<template slot-scope="{ data }">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td :data="tr.optUser">{{ tr.optUser }}</vs-td>
						<vs-td :data="tr.optTime">{{ tr.optTime }}</vs-td>
						<vs-td :data="tr.optDetail">{{ tr.optDetail }}</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vs-popup>       
    <el-dialog
        title="支付凭证查看"
        :visible.sync="payPicsShow"
        append-to-body
        width="50%">
            <el-image
                v-for="(url,index) in detail.payPics"
                style="width: 100px; height: 100px"
                :src="url" 
                :key="index"
                :preview-src-list="detail.payPics">
            </el-image>
    </el-dialog>
    <BreakUpOrder @success="handleBreakUpOrderSuccess" :visible.sync="breakUpOrderShow" :tableData="breakUpOrderList" :orderNo="orderNo" />
            
    </div>
</template>

<script>
import store from '../../store.js';
import { OrderApi } from '@/modules/server-api/commodity-sys/order';
import { LogisticsApi } from '@/modules/server-api/commodity-sys/logistics';
import {
    WmsWarehouseApi,
    Mod_Warehouse_Types_Options //库存类型
} from '@/modules/server-api/wms-manage/warehouse';
import skuList from './skuList';
import { $busErrorCode } from "@/modules/commodity-sys/common.js";
import BreakUpOrder from "../components/BreakUpOrder"
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
    components: {
        skuList,
        BreakUpOrder
    },
    mixins: [store],
    computed: {
        validateVerify() {
            return (this.deliverParam.wsId !== '' && !this.deliverParam.locId !== ''  && this.deliverFlag)
        }
    },
    data() {
        return {
          breakUpOrderShow: false,
          deliverFlag: false,
          breakUpOrderList: [],
          currentOrderNo: '',
          payPicsShow: false,
          orderNo: '',
          orderSearchInfo:{}, // 订单页查询条件
          parentUrl: '/modules/order/order', //列表页链接
          detail: [],
          breadcrumb: [],
          isEditReceiveUser: false,
          sellerRemark: '',
          TreeAbnormal: [], //订单状态数组
          AbnormalModel: '', //标注异常原因
          cancelModel: '', //取消订单原因
          cancelDriveModel: '', //取消推单原因
          tmsFrtOptions: [], //运费模板选项
          distOptions: [], //分仓选项
          locOptions: [], //仓位选项
          deliverParam: {
              frtId: '',
              wsId: '',
              locId: ''
          },
          showDeliverPop: false, //发货
          popupActive2Shqr: false, //审核确认
          popupActive2Zxdd: false, //取消推单
          popupActive2Qxdd: false, //取消订单
          popupActive2Bzyc: false, //标注异常
          popupActive2Zzc: false, //转正常
          searchTimer:null,
          addPayList:[],           //新增的支付信息
          isShowLogList : false,	//操作日志弹框
          logList : [],				//操作日志
          editFlag : false,       //是否可以编辑
          stockData: [],
          stockTabledata: [],
          skuCodes:[],
          verifyConfirmId: [],
          initFlag: true, //初始化
          amountData:{},
          currencyShow: '',
          options: regionData,
        };
    },
    mounted() {
        sessionStorage.setItem('searchFlag', true);
        sessionStorage.setItem('detailFlag', true);
        // this.orderSearchInfo = this.$route.params;
        this.detail = JSON.parse(sessionStorage.getItem('detail'));
        //格式化地址
        this.formatAddress();
        this.orderNo = this.detail.orderNo;
        // console.log(this.detail);
        let flag = this.detail.orderStatus != 'SEND_ED' && this.detail.orderStatus != 'CANCEL_ED' && this.detail.orderStatus != 'ABNORMAL';
        // console.log(flag + '====flag');
        this.editFlag = sessionStorage.getItem("editFlag") || false;
        sessionStorage.removeItem("editFlag");
        console.log("editFlag", this.editFlag);
        this.getAbnormalList();
        this.showStorageInfo();
        //菜单导航
        this.breadcrumb = [
            {
                title: '订单管理',
                url: this.parentUrl
            },
            {
                title: '订单详情',
                active: true
            }
        ];
    },
    methods: {
        //省市区联动信息处理
        handleChange (addressArr) {
            console.log(addressArr)
            if(addressArr.length > 0){  
                this.detail.province = CodeToText[addressArr[0]];
                this.detail.city = CodeToText[addressArr[1]];
                let currArea = CodeToText[addressArr[2]] ? (CodeToText[addressArr[2]] == this.allText ? this.otherText : CodeToText[addressArr[2]]) : '';
                this.detail.area =  currArea;
                // console.log('地址信息',this.detail.area)         
            }
        },
        //地址信息渲染
        showStorageInfo(){
            //地址信息
            if(this.detail.province != ''){
                let currArea = this.detail.area ? (this.detail.area == this.otherText ? this.allText : this.detail.area) : '';
                // console.log('==this.detail==', this.detail);
                let currAddressCode = currArea ? TextToCode[this.detail.province][this.detail.city][currArea].code : TextToCode[this.detail.province][this.detail.city].code;
                console.log('currAddressCode收货地址信息',currAddressCode)
                this.selectedOptions = currAddressCode;
            }
        },
        //更新币种
        updateCurrency(currency){
          this.currencyShow = currency;
        },
         // =============================== 审核确认
        async verifyConfirm(tr, index) {
            // todo
            if (this.amountData.dealTotalPrice != this.amountData.actualTotalPrice) {
                 this.$notifyError("实付与成交金额不同，请修改");
            }
            //清空
            this.deliverParam = {
                wsId: '',
                locId: ''
            }
            this.skuCodes = [];
            this.stockData = [];
            this.verifyConfirmId = [this.orderNo]
            await this.getDistList();
            await this.handleReviewDetail(this.verifyConfirmId)
            this.judgeShqr = false;
            this.popupActive2Shqr = true;
        },
        async handleReviewDetail(sendIds) {
            const res = await OrderApi.reviewDetail({orderNos: sendIds})
            if(res.succ === 1) {
                this.stockData = res.result
                this.stockData = res.result.map(item => {
                    return {
                        ...item,
                        newSendSkuName: '',
                        newSendAmount: ''
                    }
                })
                this.stockTabledata = this.stockData;
                this.skuCodes = this.stockData.map(item =>{
                    return item.skuCode;
                });
            }
        },
        //订单审核确认
        async OnconfirmOrder() {
            let orderNos = [];
            orderNos.push(this.orderNo);
            const params = {
                orderNos,
                wsId: this.deliverParam.wsId,
                locId: this.deliverParam.locId,
            }
            const res = await OrderApi.batchReview(params)
            if(res.succ === 1) {
                this.$notifySuccess('审核成功');
                this.orderNo = ''
                setTimeout(()=>{
                    this.goParentPage();
                },0)
            } else {
                this.$notifyError(res.error);
            }
            this.popupActive2Shqr = false;
        },
        //取消订单审核确认
        Onconfirmbtn() {
            this.popupActive2Shqr = false;
        },


        handleSeparateBill(){
            this.breakUpOrderList = []
            this.breakUpOrderShow = true
            this.breakUpOrderList = JSON.parse(JSON.stringify(this.detail.skuItems)) 
        },
        handleBreakUpOrderSuccess(){
            this.editFlag = 'false'
            this.$notifySuccess('拆单成功')
        },
        async editReceiveUser() {
            let res = await OrderApi.updateOrderInfo({
                province: this.detail.province,
                city: this.detail.city,
                area: this.detail.area,
                orderNo: this.orderNo,
                receiveName: this.detail.receiveName,
                receivePhone: this.detail.receivePhone,
                address: this.detail.address
            });
            if (res.succ == 1) {
               this.$notifySuccess('收货人信息保存成功');
               this.isEditReceiveUser = false;
               this.$refs["skuItem"].getOrderGoodsList();
               this.formatAddress();
            }
            else{
                return this.$notifyError(res.error);
            }
        },
        //返回父级
        goParentPage() {
            sessionStorage.removeItem('detail');
            this.$router.push({ path: this.parentUrl }).catch(() => {});
        },
        //获取状态文字样式
        getStatusClass() {
            let status = this.detail.orderStatus;
            let className = 'title ';
            switch (status) {
                case 'TO_SEND':
                case 'TO_REVIEW':
                    className += 'yellow-text';
                    break;
                case 'SEND_ED':
                    className += 'green-text';
                    break;
            }
            return className;
        },
        
        // 取消推单
        cancelDriveOrder(){
            this.popupActive2Zxdd = true;
        },
        // 取消订单
        cancelOrder() {
            this.popupActive2Qxdd = true;
            this.judgeQxdd = false;
        },
         //异常标注类型列表
        async getAbnormalList() {
            let res = await OrderApi.AbnormalList({});
            this.TreeAbnormal = res.result;
        },
        // 转异常
        toAbnormal() {
            this.popupActive2Bzyc = true;
        },
        // 转正常
        toNormal() {
            this.popupActive2Zzc = true;
        },
        
        //点击转异常
        iconabnormal() {
            this.judgeZyc = true;
            this.popupActive2Bzyc = true;
        },
        //确认转异常
        async OnOrderAbnormal() {
            let TreeAbnormal = this.TreeAbnormal
            const AbnormalModel = TreeAbnormal.filter(item => {
                if(item.key == this.AbnormalModel) {
                    return item
                }
            })
            let orderNos = [];
            orderNos.push(this.orderNo);
            let res = await OrderApi.OrderAbnormalChoice({
                orderNos: orderNos,
                warnMessage: AbnormalModel[0].val    //转异常描述
                // warnMessage: AbnormalModel[0].key  //转异常编码
            });
            if (res.succ == 1) {
                this.popupActive2Bzyc = false;
                this.$notifySuccess('标注成功');
                setTimeout(()=>{
                    this.goParentPage();
                },0)
            } else {
                this.$notifyError(res.error);
                this.popupActive2Bzyc = false;
            }
        },
        //取消转异常
        OrderAbnormalbtn() {
            this.popupActive2Bzyc = false;
        },

        // 确认转正常
        async OnNormalOk() {
            let orderNos = [];
            orderNos.push(this.orderNo);
            let res = await OrderApi.OrderTonormal({
                orderNos: orderNos
            });
            if (res.succ == 1) {
                this.$notifySuccess('转正常成功');
                setTimeout(()=>{
                    this.goParentPage();
                },0)
            } else {
                this.$notifyError(res.error);
            }
            this.popupActive2Zzc = false;
        },
        // 取消推单确认
        async OncancelDriveOrder() {
             // this.popupActive2Zxdd = false;
            let orderNos = [];
            orderNos.push(this.detail.orderNo )
            //取消订单原因
            let res = await LogisticsApi.cancelDriveOrderChoice({
                orderNos: orderNos,
                cancelReason: this.cancelDriveModel
            });
            if (res.succ == 1) {
                this.popupActive2Zxdd = false;
                this.$notifySuccess('取消成功');
                // this.getTableData();
            } else {
                this.$notifyError(res.error);
                this.popupActive2Zxdd = false;
            }
             this.OrderDriveselected = [];
             this.getOrderformList();
        },
        // 取消推单取消
        OncancelDrivebtn() {
            this.popupActive2Zxdd = false;
        },
        //取消订单
        async OncancelOrder() {
            let orderNos = [];
            orderNos.push(this.orderNo);
            let res = await OrderApi.cancelOrderChoice({
                orderNos: orderNos,
                warnMessage: this.cancelModel
            });
            if (res.succ == 1) {
                this.popupActive2Qxdd = false;
                this.$notifySuccess('取消成功');
                setTimeout(()=>{
                    this.goParentPage();
                },0)  
            } else {
                this.$notifyError(res.error);
                this.popupActive2Qxdd = false;
            }
        },
        //取消取消订单
        Oncancelbtn() {
            this.orderNo = '';
            this.popupActive2Qxdd = false;
        },
        //取消转正常
        normalbtn() {
            this.popupActive2Zzc = false;
        },
        //发货
        async handleSend() {
            //获取选项值
            this.getDistList();
            this.getTmsFrtOptions();
            this.showDeliverPop = true;
        },
        //获取分仓
        async getDistList() {
            let resp = await WmsWarehouseApi.getWarehouseAll({
                suggest: '',
                type: Mod_Warehouse_Types_Options[2].id
            });
            this.distOptions = resp.result.map(item => {
                let obj = {};
                obj.id = item.wsId;
                obj.label = item.wsName;
                return obj;
            });
        },
        //获取仓位
        async getLocOptions(id) {
            let wsId = id || this.deliverParam.wsId;
            this.deliverParam.locId = '';
            if (wsId == '') {
                this.$notifyError('请先选择仓库');
            } else {
                let resp = await WmsWarehouseApi.getLocAll({
                    wsId: wsId
                });
                this.locOptions = resp.result
                    ? resp.result.map(item => {
                          let obj = {};
                          obj.id = item.id;
                          obj.label = item.locName;
                          return obj;
                      })
                    : [];
            }
        },
        //获取所有运费模板
        async getTmsFrtOptions() {
            let resp = await LogisticsApi.getTmsFrtOptions({ suggest: '' });
            if (resp.succ == 1 && resp.result) {
                this.tmsFrtOptions = resp.result.map(item => {
                    let obj = {};
                    obj.id = item.id;
                    obj.label = item.name;
                    return obj;
                });
            }
        },
        //发货
        async deliverOrder() {
            let sendFlag = true;
            if (this.deliverParam.wsId == '') {
                sendFlag = false;
                this.$notifyError('请选择仓库');
            } else if (this.deliverParam.locId == '') {
                sendFlag = false;
                this.$notifyError('请选择仓位');
            }
            if (sendFlag) {
                this.deliverParam.orderNo = this.orderNo;
                let res = await LogisticsApi.deliverOrder(this.deliverParam);
                if (res.succ == 1) {
                    this.showDeliverPop = false;
                    this.deliverParam = {
                        frtId: '',
                        wsId: '',
                        locId: ''
                    };
                    this.$notifySuccess('发货成功');
                } else {
                    this.$notifyError(res.error);
                }
            }
        },
        
        async saveRemark(){
            let res = await OrderApi.updateOrderInfo({
                orderNo: this.orderNo,
                sellerRemark: this.detail.sellerRemark
            });
            if (res.succ == 1) {
                this.$refs["skuItem"].getOrderGoodsList();
            }
            else{
                this.$notifyError(res.error);
            }
        },
        // 面包屑返回
        back(){
            this.$router.push({ path: '/modules/order/storeOrder'}).catch(() => {});
            // this.$router.push({ name: 'order-management'}).catch(() => {});
        },
        
        clearTimer() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
        },
        
        //获取新增支付信息
        getAddPayList(val){
            if(val){
                this.detail.payRecords = val
                console.log(this.detail.payRecords, 'this.detail.payRecords')
            }
        },
        // 获取订单金额详情
        getAmountInfo(val){
            if(val){
                this.amountData = val
                console.log(this.amountData, 'amountData')
            }
        },
        
        //获取更新的卖家备注信息
        getSellerRemark(val){
            if(val){
                sessionStorage.setItem(this.detail.sellerRemark,val)
                this.detail.sellerRemark = val;
            }
        },
        
        //获取更新收货人信息
        getReceiveInfo(val){
            if(val){
                sessionStorage.setItem(this.detail.receiveName,val.receiveName);
                sessionStorage.setItem(this.detail.receivePhone,val.receivePhone);
                sessionStorage.setItem(this.detail.address,val.address);
                this.detail.receiveName = val.receiveName;
                this.detail.receivePhone = val.receivePhone;
                this.detail.address = val.address;
            }
        },
        
        //取消支付
        async delPay(item){
            let res = await OrderApi.delAddPayType({
                orderNo: this.orderNo,
                payNo: item.payNo
            });
            if (res.succ == 1 && res.code != $busErrorCode) {
                this.$refs["skuItem"].getOrderGoodsList();
                this.$notifySuccess('取消支付成功');
            }
            else{
                return this.$notifyError(res.error);
            }
        },
		
      //获取操作日志
      async getLogList(){
        this.isShowLogList = true;
        let res = await OrderApi.getOptLogList({
          orderNo: this.orderNo,
        });
        if(res.succ == 1){
          if(res.code == 0){
            this.logList = res.result;
          }else{
            return this.$notifyError(res.error);
          }
        }else{
          return this.$notifyError(res.error);
        }
      },
      //格式化地址
      formatAddress(){
        let province = this.detail.province || '';
        let city = this.detail.city == '市辖区' ? '' : this.detail.city;
        let address = this.detail.address;
        this.detail.addressAll = province + city + this.detail.area + address;
      }
    },
    watch: {
      'detail.sellerRemark'(val) {
        this.clearTimer();
        if(!this.initFlag){//初始化的时候不保存
          this.searchTimer = setTimeout(() => {
              if(val){
                  this.saveRemark()
              }
          }, 500);
        }else{
          this.initFlag = false;
        }  
      }
    },
};
</script>


<style lang="scss">
.el-image-viewer__wrapper {
    z-index: 10000 !important;
}
</style>

<style lang="scss" scoped>
@import '@/modules/commodity-sys/commodity.scss';
@mixin flex-mixin($direction, $align, $justify) {
    display: flex;
    flex-direction: $direction;
    align-items: $align;
    justify-content: $justify;
}
.w200{
    width: 200px;
}

.edit_row_input {
    display: inline-block;
    font-size: 13px !important;
    .vs-input--input.small {
        font-size: 13px !important;
    }
}
.main-wrap {
    font-family: PingFangSC-Regular, PingFang SC;
    background-color: #fff;

    .top-title {
        @include flex-mixin(row, center, flex-start);
        height: 73px;
        color: #5e5873;
        font-size: 14px;
        border-bottom: 4px solid #f7f7fa;
        padding: 0 20px;
		position:relative;
        .yellow-text {
            color: #ff8d23;
        }
        .green-text {
            color: #2dc44b;
        }
        .red-text {
            color: #ff433d;
        }
        .title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }
		.log-btn{
			position: absolute;
			right: 15px;
			top: 24px;
			font-size: 15px;
			color: #3f90ff;
			cursor:pointer;
		}
    }
    .bot-content {
        // height: 927px;
        padding: 20px 20px 100px;
        width: 100%;
        .label {
            font-size: 18px;
            color: #5e5873;
            height: 73px;
            line-height: 73px;
            margin-top: 20px;
        }

        .detail-info {
            background-color: #f7f7fa;
            @include flex-mixin(row, stretch, flex-start);

            .item {
                width: 50%;
                min-height: 162px;
                border-right: 1px solid #ebe9f1;
                padding: 16px 20px;
                box-sizing: border-box;
                &.large{
                  width: 100%;
                }
                .line {
                    @include flex-mixin(row, center, space-between);
                    &.end{
                      @include flex-mixin(row, center, flex-end);
                    }
                    .btn {
                        font-size: 14px;
                        color: #3f90ff;
                        margin-right: 10px;
                        cursor: pointer;
                        .feather-icon {
                            width: 12px;
                            height: 12px;
                            vertical-align: middle;
                        }
                    }
                }
                .title {
                    font-size: 16px;
                    font-weight: 500;
                    color: #5e5873;
                }
                .content {
                    div {
                        font-size: 13px;
                        color: #5e5873;
                        font-weight: 400;
                        margin-top: 6px;
                    }
                }
                .pay-list{
                    display: flex;
                    flex-wrap: wrap;
                    .pay-content{
                      display: flex;
                      margin-right: 20px;
                      div{  
                        margin-left: 10px;
                        white-space: nowrap;
                        &.width50{
                          width: 70px;
                        }
                        &.width20{
                          width: 20px;
                        }
                        &.width150{
                          width: 150px;
                        }
                        &.width200{
                          width: 200px;
                        }
                        &.width400{
                          min-width: 250px;
                        }
                      }
                    }
                    .pay-add{
                       div{
                           font-size: 12px;
                           margin-top: 0px;
                       } 
                       
                    }
                    .cancel-pay{
                      cursor:pointer;
                      color: #3f90ff;
                    }
                        
                }
            }
            .rt {
                border: none;
            }
        }

        .sku-info {
            margin-bottom: 20px;
        }
    }
    .btn-group {
        padding: 24px;
        /deep/ .vs-button {
            margin-right: 12px;
            padding: 9px 42px !important;
            border-radius: 5px;
        }
    }
}
.log-popup /deep/ .vs-popup{
	width:700px
}

.el-table {
    border: none;
    /deep/ .el-table__row {
        .cell {
            white-space: pre-wrap;
        }
    }
    &::before {
        border: none;
        height: 0;
    }
}
</style>
